import React from 'react';
import { Navigate, Route, Routes, useParams, useResolvedPath } from 'react-router-dom';
import PropTypes from 'prop-types';

import camelCase from 'lodash/camelCase';

import Tabs from '../components/tabs';

const TabsContainer = ({
  className = '',
  direction = 'horizontal',
  initialTabId = '',
  onClick = () => {},
  paramName,
  queryParamsToPersist = [],
  shouldRedirectOnInvalidTab = false,
  shouldRenderAll = true,
  shouldUpdateInitialUrl = false,
  tabs = [],
  variant = 'admin',
}) => {
  const paramValue = useParams()[paramName];
  const url = useResolvedPath('..').pathname;
  const targetId = paramValue || initialTabId || tabs[0]?.id;

  if (shouldUpdateInitialUrl && !paramValue) {
    return <Navigate replace to={`${url}/${targetId}`} />;
  }

  if (shouldRedirectOnInvalidTab && paramValue) {
    const validTabIds = tabs.map((tab) => tab.id);
    const fallbackId = initialTabId || tabs[0]?.id;

    if (!validTabIds.includes(paramValue) && fallbackId) {
      return <Navigate replace to={`${url}/${fallbackId}`} />;
    }
  }

  return (
    <Tabs
      activeId={targetId}
      className={className}
      isVertical={direction === 'vertical'}
      onClick={onClick}
      queryParamsToPersist={queryParamsToPersist}
      shouldRenderAll={shouldRenderAll}
      tabs={tabs}
      url={url}
      variant={variant}
    />
  );
};

TabsContainer.propTypes = {
  className: PropTypes.string,
  direction: PropTypes.oneOf(['horizontal', 'vertical']),
  initialTabId: PropTypes.string,
  onClick: PropTypes.func,
  paramName: PropTypes.string.isRequired,
  queryParamsToPersist: PropTypes.arrayOf(PropTypes.string),
  shouldRedirectOnInvalidTab: PropTypes.bool,
  shouldRenderAll: PropTypes.bool,
  shouldUpdateInitialUrl: PropTypes.bool,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      body: PropTypes.node,
      id: PropTypes.string.isRequired,
      title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    }),
  ),
  variant: PropTypes.oneOf(['admin', 'student']),
};

const TabsRouter = ({ id = '', ...props }) => {
  const paramName = camelCase(`${id} tabId`);

  return (
    <Routes>
      <Route
        // eslint-disable-next-line react/jsx-props-no-spreading
        element={<TabsContainer paramName={paramName} {...props} />}
        path={`:${paramName}?/*`}
      />
    </Routes>
  );
};

TabsRouter.propTypes = {
  id: PropTypes.string,
};

export default TabsRouter;
